import PromoRow from "./PromoRow";
import "../../styles/table.css";

export default function PromoTable({ promos, onView, onDelete }) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Code</th>
            <th>Réduction</th>
            <th>Statut</th>
            <th className="center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {promos && promos.length > 0 ? (
            promos.map((promo) => (
              <PromoRow
                key={promo.id}
                promo={promo}
                onView={onView}
                onDelete={onDelete}
              />
            ))
          ) : (
            <tr>
              <td colSpan="6" className="emptyTable">
                Aucune promotion configurée
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}